import EditorExperience from "../../2DEditorExperience";
import EventEmitter from "../../../utils/EventEmitter";
import { UIButton, UIPanel, UIRow, UISeparator } from "../../../ui/ui.lib";

// menu
import { Menu2DConnectorPin } from "./2DMenu.ConnectorPin";
import { Menu2DListConnector } from "./2DMenu.ListConnectors";

class Menu2DConnectors extends EventEmitter {

    constructor(props) {
        super(props)
        this.editor = new EditorExperience();
        this.dom = null;

        this.amenityCats = this.editor.amenityTypes || [];

        this.menuOpen = false;

        this.initUI();

        this.editor.on('toggleMenuActive', this.onToggleMenuActive);
        this.editor.on('menuModeChanged', this.onToggleMenuActive);
    }

    initUI = () => {
        this.uiContainer = new UIPanel();
        this.uiContainer.setClass('wsMenu2DContainer')

        const uiCont = new UIRow();

        uiCont.dom.appendChild(new Menu2DListConnector(this.editor).dom);
        uiCont.addChild(new UISeparator('ws_uiSeparatorCenter'));

        if(this.amenityCats.length) {
            this.amenityCats.forEach(cat => {
                cat.type === 'connector' && uiCont.dom.appendChild(new Menu2DConnectorPin(this.editor, cat).dom);
            });
        }
        uiCont.addChild(new UISeparator());
        uiCont.addChild(new UIButton('Connector Manager', 'wsMenu2dConnectorBtn', true).onClick(() => {
            this.editor.onToggleConnectorManagerModal(true);
        }))
        this.uiContainer.addChild(uiCont);
        this.uiContainer.setDisplay('none');

        this.dom = this.uiContainer.dom;
    }

    onToggleMenuActive = () => {
        if(this.editor.menuConnectorsMode === 'CONNECTORS') {
            this.menuOpen = true;
            this.uiContainer.setDisplay('');
        } else {
            this.menuOpen = false;
            this.uiContainer.setDisplay('none');
        }
    }
}

export { Menu2DConnectors };